import styled from 'styled-components';
import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getFilterOptions, getFooterLinks } from '../new-lib/apis';
import ErrorComponent from '../new-components/ui/ErrorComponent';
import { ConfigsApis } from '../new-lib/apis/configs.apis';

const ErrorPage = () => {
  return (
    <ErrorContainer>
      <ErrorComponent />
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  width: 100%;
  height: 100vh;
`;

export const getStaticProps = async ({ locale }: GetStaticPropsContext) => {
  const [footerLinks, configVariables, filterOptions] = await Promise.all([
    getFooterLinks(locale, 'error'),
    ConfigsApis.getConfigs(locale),
    getFilterOptions(locale)
  ]);

  return {
    revalidate: 60 * 60 * 24,
    props: {
      ...(await serverSideTranslations(locale as string, [
        'common',
        'contact'
      ])),
      filterOptions: JSON.stringify(filterOptions) || '',
      configVariables,
      layout: { footerLinks }
    }
  };
};

export default ErrorPage;
